import { useMutation } from '@tanstack/react-query';
import { useUnit } from 'effector-react';

import {
  AcquisitionType,
  OnboardingFlow,
  ProfileFieldSource,
} from '@m/types/grpc/MemberOnboardingSource';
import { verifyAndRegister, userStore } from 'apps/customer/state/user';
import { visitStore } from 'apps/customer/state/visit';

import type { UseMutationOptions } from '@tanstack/react-query';
import type { VerifyAndRegisterResult } from 'apps/customer/state/user/actions';

type VerifyPhoneArgs = { otp: string; siteUuid?: string };

/** Which flow the resulting account/profile fields are attributed to. */
export type VerifyPhoneSource = {
  onboardingFlow: OnboardingFlow;
  profileFieldSource: ProfileFieldSource;
};

export function useVerifyPhone(
  options?: UseMutationOptions<VerifyAndRegisterResult, Error, VerifyPhoneArgs>,
  source?: VerifyPhoneSource,
) {
  const { phoneNumber } = useUnit(userStore);
  const { qrValidation } = useUnit(visitStore);

  const defaultSource: VerifyPhoneSource = {
    onboardingFlow: OnboardingFlow.EXPRESS,
    profileFieldSource: qrValidation
      ? ProfileFieldSource.VALIDATION_FLOW
      : ProfileFieldSource.EXPRESS_ONBOARDING,
  };
  const { onboardingFlow, profileFieldSource } = source ?? defaultSource;

  return useMutation({
    mutationFn: ({ otp, siteUuid }: VerifyPhoneArgs) =>
      verifyAndRegister({
        phoneNumber,
        code: otp,
        beginSession: true,
        acquisitionType: AcquisitionType.ORGANIC,
        onboardingFlow,
        profileFieldSource,
        siteUuid,
      }),
    ...options,
  });
}
